import React from 'react';
import { string, bool, func } from 'prop-types';
import { ActivityBookmarkPreview, Icons } from '../..';
import { ActivityMediaPreviewWrapper } from './BookmarkPreview.styles';
const CrossIcon = Icons.cross;
export const BookmarkPreview = _ref => {
  let {
    image,
    title,
    url,
    logo,
    description,
    isLoading,
    resourceId,
    isDeletable,
    deleteCallback
  } = _ref;
  return /*#__PURE__*/React.createElement(ActivityMediaPreviewWrapper, {
    isLoading: isLoading,
    "data-test-id": "preview-wrapper"
  }, isDeletable ? /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    onClick: () => deleteCallback(resourceId),
    onKeyDown: () => deleteCallback(resourceId),
    "data-test-id": "delete-button",
    className: "cross-icon-wrapper"
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    className: "cross-icon"
  })) : null, /*#__PURE__*/React.createElement(ActivityBookmarkPreview, {
    imgSrc: image,
    title: title,
    description: description,
    url: url,
    favIcon: logo,
    isLoading: isLoading
  }));
};
BookmarkPreview.propTypes = {
  image: string,
  title: string,
  url: string,
  logo: string,
  description: string,
  isLoading: bool,
  resourceId: string,
  isDeletable: bool,
  deleteCallback: func.isRequired
};
BookmarkPreview.defaultProps = {
  image: '',
  title: '',
  url: '',
  logo: '',
  description: '',
  resourceId: '',
  isDeletable: false,
  isLoading: true
};
export default BookmarkPreview;